export enum SessionStorageKeyNames {
    countries = 'countries',
    currencies = 'currencies',
    priceTypes = 'priceTypes',
    productGroups = 'productGroups',
    priceListRegion = 'priceListRegion',
}
